import { Quote } from './quote.domain';

export enum OptionType {
  CALL = 'CALL',
  PUT = 'PUT'
}

export enum OptionExpiryType {
  QUARTERLY = 'QUARTERLY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY'
}

export interface OrderEntryConfiguration {
  mloOrdersEnabled: boolean;
  complexOrdersEnabled: boolean;
  otaOrdersOptionsEnabled: boolean;
  complexOrdersOptionsEnabled: boolean;
  accountAndOrderBuyingPowerEnabled: boolean;
}

export interface OrderStatusConfiguration {
  consolidatedOrdersEnabled: boolean;
  historicalOrdersEnabled: boolean;
  orderStatusPageSize: number;
  highVolumeOrderStatusThreshold: number;
  highVolumeHistoricalThreshold: number;
  historicalOrdersDefaultPeriod: number;
}

export interface QuoteResponse {
  responseQuote: Array<Quote>;
}

// TODO check possible overlap with OptionSymbolUrlParam and refactor
export interface OptionQuoteParams {
  expiryDate: Date;
  strikePrice: number;
  optionType: OptionType;
  underlyingCompany: string; // When placing an order this will help identify quote for INDEX symbols, ie for SPX US -> underlying SPXW
  displayTicker: string; // Uniquely identifies expiry+strike+c/p
  nonStandard?: boolean;
  optionQuoteComplete?: boolean;
}

export enum OrderOperation {
  CREATE = 'CREATE',
  CHANGE = 'CHANGE',
  CANCEL = 'CANCEL'
}

export type OrderOperationType = `${OrderOperation}`;
